import angular from 'angular';


import JobNumberPopoverController from './jobNumberPopoverController';
import JobNumberPopoverFactory from './jobNumberPopoverFactory';
import PrimaryInformationController from './primaryInformationController';
import PrimaryInformationDirective from './primaryInformationDirective';


export default angular.module('app.common.primaryInformation', [])
    .controller('JobNumberPopoverController', JobNumberPopoverController)
    .controller('PrimaryInformationController', PrimaryInformationController)
    .factory('JobNumberPopoverFactory', JobNumberPopoverFactory)
    .directive('primaryInformation', PrimaryInformationDirective)
    .run(($templateCache) => {
        $templateCache.put('app/common/primaryInformation/jobNumberPopoverTemplate.html', require('./jobNumberPopoverTemplate.html')); // eslint-disable-line global-require
        $templateCache.put('app/common/primaryInformation/primaryInformationTemplate.html', require('./primaryInformationTemplate.html')); // eslint-disable-line global-require
    })
    .name;



// WEBPACK FOOTER //
// ./src/app/common/primaryInformation/index.js